import { __awaiter } from "tslib";
import downloadjs from 'downloadjs';
import * as jsonexport from "jsonexport/dist";
import { Self } from '@/vue-core';
import { status } from '@/alas';
import { defineComponent, reactive, computed, onMounted } from '@vue/composition-api';
import { showError } from '@/store';
export default defineComponent({
    setup(props, context) {
        let self = new Self(context);
        // =================
        //
        // state
        //
        let $ = reactive({
            farm: status.fetch('farm'),
            cycle: status.fetch('cycle'),
            pictures: status.fetch('pictures'),
            analysis: null,
            picture: null,
            showPicture: false
        });
        // =================
        //
        // computed
        //
        let fileName = computed(() => `${$.farm.name}-${$.cycle.$v.createdAt}-${$.cycle.$v.finishedAt}`);
        let headers = computed(() => {
            if ($.analysis && $.analysis[0]) {
                return Object.keys($.analysis[0]);
            }
            else {
                return [];
            }
        });
        // =================
        //
        // mounted
        //
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            try {
                $.analysis = yield $.cycle.$m.getAnalysis();
            }
            catch (error) {
                showError(error);
            }
        }));
        // =================
        //
        // methods
        //
        let downloadJSON = () => {
            downloadjs(JSON.stringify($.pictures.exports(), null, 4), fileName.value + '.json', 'text/plain');
        };
        let downloadCsv = () => __awaiter(this, void 0, void 0, function* () {
            let csv = yield jsonexport($.analysis);
            downloadjs(csv, fileName.value + '.csv', 'text/plain');
        });
        let getItemText = (text) => {
            if (text.length > 10) {
                return text.slice(0, 10) + '...';
            }
            else {
                return text || '-';
            }
        };
        let showPicture = (item) => {
            let date = item['日期'];
            let picture = $.pictures.items.find(e => e.$v.createdAt === date);
            $.picture = picture;
            $.showPicture = true;
        };
        // =================
        //
        // done
        //
        return {
            $,
            headers,
            getItemText,
            showPicture,
            downloadCsv,
            downloadJSON
        };
    }
});
